<template>
    <div class="dropdown-menu-project" v-if="setup != null" id="dropdown-menu-project" :class="{'open' : openSendwich}">
        <div class="container">
            <div class="drop-down-container">
                <div class="menu-navigation">
                    <div class="col">
                        <div class="nav-item" v-for="item in setup.nav_burger.slice(0, 1)">
                            <router-link :to="item.link" class="category-link" @click.native="closeMobileMenu">{{ item.category }}</router-link>
                            <ul v-if="item.dropdown != false && item.dropdown.length > 0">
                                <li v-for="item_d in item.dropdown">
                                    <router-link :to="item_d.href" @click.native="closeMobileMenu">{{ item_d.name }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col">
                        <div class="nav-item" v-for="item in setup.nav_burger.slice(1, 2)">
                            <router-link :to="item.link" class="category-link" @click.native="closeMobileMenu">{{ item.category }}</router-link>
                            <ul v-if="item.dropdown != false && item.dropdown.length > 0">
                                <li v-for="item_d in item.dropdown">
                                    <router-link :to="item_d.href" @click.native="closeMobileMenu">{{ item_d.name }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col">
                        <div class="nav-item" v-for="item in setup.nav_burger.slice(2, 5)">
                            <router-link :to="item.link" class="category-link" @click.native="closeMobileMenu">{{ item.category }}</router-link>
                            <ul v-if="item.dropdown != false && item.dropdown.length > 0">
                                <li v-for="item_d in item.dropdown">
                                    <router-link :to="item_d.href" @click.native="closeMobileMenu">{{ item_d.name }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col">
                        <div class="nav-item" v-for="item in setup.nav_burger.slice(5, 8)">
                            <router-link :to="item.link" class="category-link" @click.native="closeMobileMenu">{{ item.category }}</router-link>
                            <ul v-if="item.dropdown != false && item.dropdown.length > 0">
                                <li v-for="item_d in item.dropdown">
                                    <router-link :to="item_d.href" @click.native="closeMobileMenu">{{ item_d.name }}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="drop-menu-info">
                    <div class="menu-adres">
                        <svgIcon name="pin" class="icon-pin"/>
                        <p v-html="setup.footer_adres"></p>
                    </div>
                    <div class="phone-container">
                        <a :href="'tel:' + setup.header_phone.code + setup.header_phone.phone"><span>{{ setup.header_phone.code }}</span> {{setup.header_phone.phone }}</a>
                    </div>
                    <div class="social-items-menu">
                        <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                            <svgIcon name="instagram" class="icon-instagram"/>
                        </a>
                        <a :href="setup.footer_social_links.tiktok" class="social-item" target="_blank">
                            <svgIcon name="tiktok" class="icon-tiktok"/>
                        </a>
                        <a :href="setup.footer_social_links.youtube" class="social-item" target="_blank">
                            <svgIcon name="youtube" class="icon-youtube"/>
                        </a>
                        <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                            <svgIcon name="telegram" class="icon-telegram"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'Burger-Menu',
        components: {
            svgIcon,
        },
        data () {
            return {
                dataLang: '',
                langOpen: false,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            // salesCard: 'loadSalesCardContent',
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
            // offsetResponse: 'loadOffsetResponse',
        }),
        methods: {
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/burger-menu/burger-menu.scss';
</style>